import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import WarningIcon from '@mui/icons-material/Warning';
import { Box, Checkbox, Divider, FormControlLabel, Grid, Stack, TableCell, Typography, TableBody, TableHead, Table, TableRow } from '@material-ui/core';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import PersonIcon from '@mui/icons-material/Person';
import PhoneEnabledIcon from '@mui/icons-material/PhoneEnabled';
import MailIcon from '@mui/icons-material/Mail';
import FacebookIcon from '@mui/icons-material/Facebook';
import ShareIcon from '@mui/icons-material/Share';
import apiContact from '../../../api/contact';
import { useSnackbar } from 'notistack5';
import { useEffect, useState } from 'react';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import { useTranslation } from 'react-i18next';
import ListFieldContact from '../phonebook/ListFieldContact';
const Item = styled(Paper)(({ theme }) => ({
    direction: "row",
    display: "flex",
    spacing: "10px",
    padding: "5px",
    justifyContent: "center"
}));
const ListItem = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

export default function AlertDialogContact({ open, onClose, infoContactSelected, uid, onCloseForm, setIsRefreshContact, type, infoNew }) {

    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    const [paramUpdateContact, setParamUpdateContact] = useState({});
    const [infoCurrent, setInfoCurrent] = useState(null);
    const [listFieldContact, setListFieldContact] = useState([]);
    const submit_merge_contact = async () => {
        try {
            //console.log(paramUpdateContact )
            const status_merge_contact = await apiContact.merge_contact({ uid: uid, phone: infoContactSelected.phone, type: type, ...paramUpdateContact });
            enqueueSnackbar('Đồng bộ thành công', { variant: 'success' });
            setIsRefreshContact(true);
            onClose();
            onCloseForm();
        } catch (error) {
            enqueueSnackbar('Đồng bộ thất bại', { variant: 'success' });
        }
    }
    useEffect(() => {
        const loadFieldContact = async () => {
            try {
                const res_field_contact = await apiContact.list_field_contact();
                setListFieldContact(res_field_contact.data.data)
            } catch (error) { }

        }
        loadFieldContact();
    }, []);
    useEffect(() => {
        console.log(open);
        console.log(infoNew)
        const getInfoCurrent = async () => {
            const res_info_current = await apiContact.find({ phone: infoNew.phone });
            const data = res_info_current.data.data;
            var test = {};
            Object.keys(infoNew).map((key) => {
                if (infoNew[key] != data[key]) {
                    console.log(key)
                    console.log(infoNew.phone)
                    console.log(infoNew[key]);
                    test[key] = infoNew[key];

                }
            });
            console.log(test)
            setInfoCurrent(res_info_current.data.data);
            setParamUpdateContact(test)
        }
        if (infoNew.phone && open) {
            getInfoCurrent();
        }

    }, [infoNew, open]);
    const onHandleUpdateContact = (e) => {
        console.log(e.target.checked)
        if (e.target.checked) {
            setParamUpdateContact({ ...paramUpdateContact, [e.target.name]: infoNew[e.target.name] });
        } else {

            var paramAfterChecked = paramUpdateContact;
            const updatedObject = { ...paramUpdateContact };
            // Xóa key2 khỏi bản sao
            delete updatedObject[e.target.name];
            // Cập nhật lại đối tượng state với bản sao đã được chỉnh sửa
            setParamUpdateContact(updatedObject);
        }
    }
    const onHandleCheckAll = (e) => {
        if (e.target.checked) {
            var test = {};
            Object.keys(infoNew).map((key) => {
                if (infoNew[key] != infoCurrent[key]) {
                    console.log(key)
                    console.log(infoNew.phone)
                    console.log(infoNew[key]);
                    test[key] = infoNew[key];
                }
            });
            setParamUpdateContact(test);
        } else {
            setParamUpdateContact({});
        }

    }
    console.log(infoCurrent)
    console.log(infoNew)
    return (
        <Dialog
            open={open}
            // onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{
                '& .MuiPaper-root': {
                    width: '100%',
                    maxWidth: 800
                    , // Set your width here
                },
            }}
        >
            <DialogTitle id="alert-dialog-title">
                <Stack direction={"row"} sx={{ p: 2 }}>
                    <WarningIcon color="warning" />
                    <Typography>Thông báo</Typography>
                </Stack>
                <Divider />
            </DialogTitle>
            <DialogContent sx={{ mt: 2 }}>
                <DialogContentText id="alert-dialog-description" color="red">
                    Danh bạ mà bạn thêm đã có trong danh sách, Bạn có muốn đồng bộ với danh bạ có sẵn không?
                </DialogContentText>
                <DialogContentText id="alert-dialog-description">
                    <Paper sx={{ p: 1, maxWidth: 800 }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell><Checkbox defaultChecked={true} onChange={onHandleCheckAll} /></TableCell>
                                    <TableCell align='center'>Tất cả</TableCell>
                                    <TableCell align='right'>Thông tin cũ</TableCell>
                                    <TableCell align='center'></TableCell>
                                    <TableCell align='left'>Thông tin mới</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    infoCurrent && Object.keys(infoNew).map(function (key, index) {
                                        if (infoCurrent.hasOwnProperty(key) && infoCurrent[key] != infoNew[key] && !["oa_id", "page_id", "uid"].includes(key)) {
                                            return (
                                                <TableRow key={index}>
                                                    <TableCell><Checkbox checked={paramUpdateContact[key] ? true : false} name={key} onChange={e => onHandleUpdateContact(e)} /></TableCell>
                                                    <TableCell align='center'>{t(key)}</TableCell>
                                                    <TableCell align='right'>{infoCurrent[key]}</TableCell>
                                                    <TableCell align='center'><DoubleArrowIcon /></TableCell>
                                                    <TableCell align='left' >{infoNew[key]}</TableCell>
                                                </TableRow>
                                            )
                                        }
                                    })
                                }

                                {
                                    infoCurrent && listFieldContact.map((fieldContact, index2) => {
                                        console.log(infoCurrent)
                                        console.log(infoNew)
                                        var field_current_contact = [];
                                        var selected_value_field_current_contact = [];
                                        var selected_value_field_new_contact = []
                                        const field_new_contact = infoNew.hasOwnProperty(fieldContact.field_contact_variable);
                                        if (fieldContact.field_contact_type === "select") {
                                            field_current_contact = infoCurrent && infoCurrent['other'].length > 0 ? infoCurrent['other'].filter((c) => c.k === fieldContact.field_contact_variable) : [];
                                            selected_value_field_current_contact = field_current_contact.length > 0 ? fieldContact.field_contact_options.filter((val) => val.key === field_current_contact[0].v) : [];
                                            selected_value_field_new_contact = fieldContact.field_contact_options.filter((val) => val.key === infoNew[fieldContact.field_contact_variable])

                                        } else {
                                            field_current_contact = infoCurrent && infoCurrent['other']?.length > 0 ? infoCurrent['other'].filter((c) => c.k === fieldContact.field_contact_variable) : [];
                                        }

                                        if ((!field_new_contact && field_current_contact.length === 0) || (field_current_contact[0]?.v === infoNew[fieldContact.field_contact_variable])) {
                                            console.log(fieldContact);
                                            console.log(field_new_contact)
                                        } else if (fieldContact.field_contact_type === "select" && ((selected_value_field_current_contact.length === 0 && selected_value_field_new_contact.length === 0) || (
                                            selected_value_field_current_contact.length === 1 && selected_value_field_new_contact.length === 1 && selected_value_field_current_contact[0].label === selected_value_field_new_contact[0].label))
                                        ) {
                                            //Kiểm tra nếu 2 trường select = nhau hoặc đều ""
                                        }
                                        else {
                                            return (
                                                <TableRow key={index2}>
                                                    <TableCell><Checkbox checked={paramUpdateContact[fieldContact.field_contact_variable] ? true : false} name={fieldContact.field_contact_variable} onChange={e => onHandleUpdateContact(e)} /></TableCell>
                                                    <TableCell align='center'>{fieldContact.field_contact_name}</TableCell>
                                                    {fieldContact.field_contact_type != "select" ? <TableCell align='right' >{field_current_contact.length > 0 ? field_current_contact[0].v : ""} </TableCell>
                                                        : <TableCell align='right'>{selected_value_field_current_contact.length > 0 ? selected_value_field_current_contact[0].label : ""}</TableCell>}
                                                    <TableCell align='center'><DoubleArrowIcon /></TableCell>
                                                    {fieldContact.field_contact_type != "select" ? <TableCell align='left' >{field_new_contact && infoNew[fieldContact.field_contact_variable]}</TableCell>
                                                        : <TableCell align='left' >{field_new_contact && selected_value_field_new_contact[0]?.label}</TableCell>}
                                                </TableRow>
                                            )
                                        }

                                    })
                                }
                            </TableBody>
                        </Table>
                    </Paper>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Hủy bỏ</Button>
                <Button onClick={submit_merge_contact} autoFocus>
                    Đồng ý
                </Button>
            </DialogActions>
        </Dialog>

    );
}